export default class Hook {
    static publish(_hId, data) {
        document.dispatchEvent(new CustomEvent(_hId, data));
    }

    static subscribe(_hId, cb, opts) {
        document.addEventListener(
            _hId,
            (e) => {
                e.stopImmediatePropagation();

                cb(e);
            },
            opts
        );
    }

    static attachListener(eventName) {
        for (const hook of document.querySelectorAll("[data-hook='" + eventName + "']")) hook.addEventListener("click", this.#cb, true);
    }

    static attachListeners() {
        for (const hook of document.querySelectorAll("[data-hook]")) hook.addEventListener("click", this.#cb, true);
    }

    static #cb = (e) => {
        e.preventDefault();

        const attributes = e.currentTarget.dataset;

        if (attributes.hook !== "") {
            Hook.publish(attributes.hook, {
                detail: {
                    event: e,
                },
            });
        }
    };
}
